export default function flagToBool(flag) {
  return flag == 1;
}